/* omc-shipbar-items v1 — free UK shipping progress based on ITEM COUNT (2+), UK/GBP only */
(function () {
  var NEEDED = 2;
  var SEL = '.cart-totals';
  var busy = false, timer = null;

  function eligible(cart) {
    if (window.__OMC_COUNTRY && window.__OMC_COUNTRY !== 'GB') return false;
    if (cart && cart.currency && cart.currency !== 'GBP') return false;
    return true;
  }

  function build(count) {
    var remaining = NEEDED - count;
    var pct = Math.max(0, Math.min(100, (count / NEEDED) * 100));
    var done = remaining <= 0;

    var wrap = document.createElement('div');
    wrap.className = 'omc-itembar' + (done ? ' omc-itembar--done' : '');

    var msg = document.createElement('p');
    msg.className = 'omc-itembar__msg';
    if (done) {
      msg.textContent = 'Free shipping unlocked. Nice one.';
    } else if (remaining === 1) {
      msg.innerHTML = 'Add <strong>1 more item</strong> for free shipping';
    } else {
      msg.innerHTML = 'Add <strong>' + remaining + ' items</strong> for free shipping';
    }

    var track = document.createElement('div');
    track.className = 'omc-itembar__track';
    var fill = document.createElement('div');
    fill.className = 'omc-itembar__fill';
    fill.style.width = pct + '%';
    track.appendChild(fill);

    wrap.appendChild(msg);
    wrap.appendChild(track);
    return wrap;
  }

  function render() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        busy = false;
        var targets = document.querySelectorAll(SEL);
        for (var i = 0; i < targets.length; i++) {
          var t = targets[i];
          var parent = t.parentNode;
          if (!parent) continue;
          var old = parent.querySelector('.omc-itembar');
          if (old) old.parentNode.removeChild(old);
          if (!eligible(cart)) continue;
          if (!cart.item_count) continue;
          parent.insertBefore(build(cart.item_count), t);
        }
      })
      .catch(function () { busy = false; });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(render, 180); }

  if (window.fetch) {
    var orig = window.fetch;
    window.fetch = function () {
      var url = '';
      try { url = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] && arguments[0].url) || ''; } catch (e) {}
      var p = orig.apply(this, arguments);
      if (/\/cart/.test(url)) { p.then(function () { schedule(); }).catch(function () {}); }
      return p;
    };
  }

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches(SEL)) || (n.querySelector && n.querySelector(SEL))) return schedule();
      }
    }
  });

  function start() {
    schedule();
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
